import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import defaultImage from "assets/images/white.jpg";
import { colors } from "common/const/colors";
import { ImagePreview } from "../Button/new/ImagePreview";
import { Column, Row } from "../Layout/new/constLayout";
import { TextButton2, TextPlaceholder, TextTitle2 } from "..";

const HomeCCCard = ({ item }) => {
  return (
    <HomeCardLayout
      onClick={() => {
        // 클럽 상세는 setClub → useAccessManager가 부르면서 currency/operatingHoles 등을
        // 마저 채운다. 여기서 또 부르면 같은 API가 두 번 나가므로, 목록에 이미 있는
        // 값만 동기로 먼저 세팅한다.
        window.setClub(item.id);
        localStorage.setItem("clubId", item.id);
        localStorage.setItem("country", item.country);
        localStorage.setItem("clubName", item.name);
      }}
      to={"/insights"}
      style={{
        textDecoration: "none",
      }}>
      <CardImageDiv>
        <ImagePreview
          src={item.attachmentRef ?? item.imageRef ?? defaultImage}
          width={"100%"}
          height={"100%"}
          isVideo={item.attachmentType === "video/mp4"}
          alt="club"
        />
      </CardImageDiv>
      <CardText>
        <Column gap={"0.5rem"}>
          <TextTitle2 color={colors.DarkNavy}>{item.name}</TextTitle2>
          <TextPlaceholder color={colors.DarkNavy}>
            {item.country}
          </TextPlaceholder>
        </Column>
        <Row $align={"flex-end"} $justify={"space-between"}>
          <TextPlaceholder color={colors.LightNavy}>
            {item.roleName}
          </TextPlaceholder>
          {/* <InfoIcon style={{ width: "24px", height: "24px" }} /> */}
        </Row>
      </CardText>
    </HomeCardLayout>
  );
};

const HomeCardLayout = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  min-width: 16rem;
  max-width: 24rem;
  width: 100%;
  aspect-ratio: 49 / 40;
  border: none;
  background-color: var(--White);
  border-radius: var(--border-radius-16);
  box-shadow: var(--box-shadow);
`;

const CardImageDiv = styled.div`
  width: 100%;
  height: 70%;
  overflow: hidden;
  border-top-left-radius: var(--border-radius-16);
  border-top-right-radius: var(--border-radius-16);
  box-sizing: border-box;
`;

const CardText = styled.div`
  width: 100%;
  height: 30%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 1rem;
  box-sizing: border-box;
`;

export { HomeCCCard };

/**
 * 범용 카드 컨테이너.
 * @param {Object} props
 * @param {React.ReactNode} [props.title] - 카드 제목
 * @param {React.ReactNode} [props.titleRight] - 제목 오른쪽 액션 슬롯(삭제 버튼 등)
 * @param {React.ReactNode} props.children
 * 나머지 props(style, className 등)는 컨테이너로 전달된다.
 */
export const Card = ({ title, titleRight, children, padding, ...rest }) => {
  return (
    <CardContainer $padding={padding} {...rest}>
      {(title != null || titleRight) && (
        <CardHeader>
          {title != null && <TextButton2>{title}</TextButton2>}
          {titleRight}
        </CardHeader>
      )}
      {children}
    </CardContainer>
  );
};

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.25rem;
  padding: ${({ $padding }) => $padding || "1.5rem"};
  background-color: ${colors.GhostWhite};
  border-radius: var(--border-radius-16);
  box-sizing: border-box;
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;
